import { postAuth, handleResponse } from "./base.service";
import { CONTROLLER, ACTION } from "../utilities/api.constants";

export const getSalesDocumentRequestsService = (memberId) => {
  return postAuth(CONTROLLER.DELIVERY_REQUEST + ACTION.GET_SALES_DOCUMENT_REQUESTS, {
    memberId: Number(memberId),
  }).then(handleResponse);
};

export const getSalesDocumentRequestDetailService = (memberId, requestId) => {
  return postAuth(CONTROLLER.DELIVERY_REQUEST + ACTION.GET_SALES_DOCUMENT_REQUEST_DETAIL, {
    memberId: Number(memberId),
    requestId: Number(requestId),
  }).then(handleResponse);
};

export const uploadSalesDocumentsService = (payload) => {
  return postAuth(CONTROLLER.DELIVERY_REQUEST + ACTION.UPLOAD_SALES_DOCUMENTS, payload).then(handleResponse);
};

export const downloadSalesDocumentService = (payload) => {
  return postAuth(CONTROLLER.DELIVERY_REQUEST + ACTION.DOWNLOAD_SALES_DOCUMENT, payload).then(handleResponse);
};
